export default __webpack_public_path__ + "static/media/good-question.abaed098.gif";